<div
  class="col-12"
  *ngIf="isLoading"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  "
>
  <app-progress></app-progress>
</div>
<div class="page_header annual_compliance_details_header">
  <h1 class="heading">Process Annual Compliance Certificates</h1>
</div>
<!-- View and Process Annual Compliance Certificates Screen 18 starts here -->
<div class="view_annual_compliance">
  <div class="compliance_details">
    <h2 >Annual Compliance Certificate <span *ngIf="complainceDetailsData?.Is_duplicate">Duplicate</span></h2>
    <div class="detail_row">
      <div class="column">Account ID:</div>
      <div class="column">{{ complainceDetailsData?.carrier_id }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Permit Number:</div>
      <div class="column">{{ complainceDetailsData?.permit_num }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Application Date:</div>
      <div class="column">
        {{ complainceDetailsData?.date_created | date : "dd/MM/yyyy" }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">Applicant:</div>
      <div class="column">{{ complainceDetailsData?.trading_name }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Email Address:</div>
      <div class="column">{{ complainceDetailsData?.email }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Physical Address:</div>
      <div class="column">
        {{ complainceDetailsData?.physical_address_1 }}
        <br />{{ complainceDetailsData?.physical_address_2 }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">Country:</div>
      <div class="column">{{ countryName }}</div>
    </div>
    <div class="detail_row">
      <div class="column">Post Code:</div>
      <div class="column">{{ complainceDetailsData?.postalCode }}</div>
    </div>
  </div>
  <br />
  <h2>2. Permit Details</h2>
  <div class="table-responsive">
    <table class="table custom_table" cellspacing="0" width="100%">
      <thead>
        <tr>
          <th>Vehicle Registration Number</th>
          <th class="permit_type">Permit type</th>
          <th>Permit Number</th>
          <th class="text-right">Permit Start date</th>
          <th class="text-right">Permit end date</th>
          <th class="text-right">Compliance Start date</th>
          <th class="text-right">Compliance End date</th>
          <th>Status</th>
          <th class="text-right">Duplicate Fee</th>
          <th class="text-right">Line Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ complainceDetailsData?.registration_number }}</td>
          <td>
            {{ complainceDetailsData?.permit_type }}
            <!-- <span style="white-space: nowrap">(Up to 20 000kg)</span> -->
          </td>
          <td>{{ complainceDetailsData?.permit_num }}</td>
          <td class="text-right">
            {{ complainceDetailsData?.permit_start | date : "dd/MM/yyyy" }}
          </td>
          <td class="text-right">
            {{ complainceDetailsData?.permit_end | date : "dd/MM/yyyy" }}
          </td>
          <td class="text-right">
            {{ complainceDetailsData?.date_valid_from | date : "dd/MM/yyyy" }}
          </td>
          <td class="text-right">
            {{ complainceDetailsData?.date_valid_to | date : "dd/MM/yyyy" }}
          </td>
          <td>{{ complainceDetailsData?.compliance_status }}</td>
          <td class="text-right">
            R{{
              complainceDetailsData?.duplicate_fee == null
                ? "0"
                : complainceDetailsData?.duplicate_fee
            }}
          </td>
          <td class="text-right">
            R{{
              complainceDetailsData?.line_total == null
                ? "0"
                : complainceDetailsData?.line_total
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <br />
  <h2>3. Documents</h2>
  <div class="uploaded_files_wrapper">
    <ng-container *ngFor="let docGroup of allDocs | keyvalue">
     <ul class="uploaded_files_list">
          <li *ngFor="let doc of docGroup.value">
            <span class="name">{{ doc.fileName }}</span>
            <span class="type">PDF</span>
            <span class="file_size">{{ doc.date_created | date : 'dd/MM/yyyy h:mm a' }}</span>
            <div class="actions">
              <button
              type="button"
              class="btn_icon"
              data-toggle="modal"
              data-target="#exampleModalLong"
              aria-label="View file"
              (click)="
                viewDoc(doc)
              "
            >
              <img src="assets/visibility.png" alt="" />
            </button>
            </div>
          </li>
        </ul>
    </ng-container>
  </div>
  <br />
<!--   <div class="links_row row">
    <div
      class="column"
      *ngIf="complainceDetailsData?.compliance_status != 'Rejected'"
    >
      <a (click)="onReject()">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span class="link_text">Reject</span>
      </a>
    </div>
    <div
      class="column"
      *ngIf="complainceDetailsData?.compliance_status != 'Approved'"
    >
      <a (click)="onApproved()">
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span class="link_text">Approved</span>
      </a>
    </div>
    <div class="column">
      <a (click)="onChangeStatus()">
        <span class="icon">
          <i class="fa fa-refresh"></i>
        </span>
        <span class="link_text">Change status</span>
      </a>
    </div>
    <div
      class="column"
      *ngIf="complainceDetailsData?.compliance_status != 'OnHold'"
    >
      <a (click)="onHold()">
        <span class="icon">
          <i class="fa fa-pause-circle-o"></i>
        </span>
        <span class="link_text">On hold</span>
      </a>
    </div>
  </div> -->
</div>
<!-- View and Process Annual Compliance Certificates Screen 18 ends here  -->

<!-- View document in model -->
<div
  class="modal fade"
  id="annualcomplianceDocument"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Document Upload</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <img [src]="img" *ngIf="img" alt="" />
          <ngx-loading [show]="isLoadingFile"></ngx-loading>
        </div>

        <div style="width: 99%; min-height: 470px" class="text-center"></div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary btn-close"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
aria-hidden="true">
<div class="modal-dialog modal-lg" role="document">
   <div class="modal-content">
       <div class="modal-header">
           <h5 class="modal-title" id="exampleModalLongTitle">View Uploaded Doc</h5>
           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
               <span aria-hidden="true">&times;</span>
           </button>
       </div>

       <div class="modal-body modal-lg">

           <div style="width: 99%; min-height: 470px;" >

               <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;"
                           [original-size]="false" [autoresize]="true"></pdf-viewer>
           
               <img [src]="img" *ngIf="img">
               <ngx-loading [show]="isLoadingImg"></ngx-loading>
           </div>


       </div>   
  </div>
     
  


